import React from "react";
import YouTube from "react-youtube";
import { Box } from "@mui/material";

function getYouTubeVideoId(url) {
  // Extract the video ID from various YouTube URL formats
  const patterns = [
    /(?:youtube\.com\/shorts\/)([\w-]+)/, // Shorts: https://www.youtube.com/shorts/VIDEO_ID
    /(?:youtube\.com\/watch\?v=)([\w-]+)/, // Regular: https://www.youtube.com/watch?v=VIDEO_ID
    /(?:youtube\.com\/embed\/)([\w-]+)/, // Embed: https://www.youtube.com/embed/VIDEO_ID
    /(?:youtu\.be\/)([\w-]+)/, // Short URL: https://youtu.be/VIDEO_ID
    /[?&]v=([\w-]+)/, // Fallback: any URL with ?v= or &v=
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
}

const YouTubeVideo = ({ url }) => {
  const videoId = getYouTubeVideoId(url);

  const opts = {
    width: "100%",
    heigth: "auto",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  return (
    <Box pt="1rem" width="100%">
      <YouTube videoId={videoId} opts={opts} />
    </Box>
  );
};

export default YouTubeVideo;
